const Joi = require('joi')
const fields = require('../fields')

const nicknameSchema = Joi.object({
    nickname: fields.nicknameField.required(),
})

module.exports = nicknameSchema